import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Footer } from 'src/components/moleculesLegacy/Footer';
import { LoginPageLayout } from 'src/components/organisms/Common/LoginPageLayout';
import { HeaderLogo, HeaderTitle } from '../CustomHeader/CustomHeader.styles';

interface Props {
  children: ReactNode;
  organisation: string;
  logo?: string;
}

export const OpenReportingContainer = (props: Props) => {
  const { t } = useTranslation();
  if (!props.organisation) return null;

  return (
    <LoginPageLayout
      header={
        <>
          <HeaderLogo
            src={props.logo}
            alt={t('public.CustomHeader.companyLogo', {
              company: props.organisation,
            })}
            data-testid={'opr-header-link'}
          />
          <HeaderTitle>{t('public.CustomHeader.openReporting')}</HeaderTitle>
        </>
      }
      footer={<Footer />}
    >
      {props.children}
    </LoginPageLayout>
  );
};
